// Lib
import React from 'react';
import { useSelector } from 'react-redux';
import { useDragLayer } from 'react-dnd';

// Utils
import { isLineAffectedByDrag } from './dragLayerUtil';

// Selectors
import { getPlatformDetailsSelector } from '../../platform/platformSelector';

// Components
import LineDragLayer from './lineDrag/LineDragLayer';
import CanvasViewportReplica from './CanvasViewportReplica';
import DragLayerErrorRenderer from '../../workspace/dnd/DragLayerErrorRenderer';
import ErrorBoundary from '../../components/error/errorBoundary/ErrorBoundary';

// Types
import { MilanoteApplicationMode } from '../../../common/platform/platformTypes';

// Styles
import './ConnectedElementDragLayer.scss';

type ConnectedElementDragLayerProps = {
    currentBoardId: string;
};

const ConnectedElementDragLayer = ({ currentBoardId }: ConnectedElementDragLayerProps) => {
    const platformDetails = useSelector(getPlatformDetailsSelector);

    const { itemType, item, isDragging } = useDragLayer((monitor) => ({
        isDragging: monitor.isDragging(),
        itemType: monitor.getItemType(),
        item: monitor.getItem(),
    }));

    if (platformDetails.appMode === MilanoteApplicationMode.mobileLegacy) return null;
    if (!isDragging) return null;
    if (!isLineAffectedByDrag(item, itemType)) return null;

    return (
        <div className="ConnectedElementDragLayer">
            <ErrorBoundary ErrorRenderer={DragLayerErrorRenderer}>
                <CanvasViewportReplica currentBoardId={currentBoardId}>
                    <LineDragLayer currentBoardId={currentBoardId} />
                </CanvasViewportReplica>
            </ErrorBoundary>
        </div>
    );
};

export default ConnectedElementDragLayer;
